import React from "react";
import { ShieldAlert } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import AdminConnectionsPanel from "@/components/AdminConnectionsPanel";
import GradientMesh from "@/components/GradientMesh";

export default function AdminPlatformSetupPage() {
  return (
    <div className="relative">
      <GradientMesh />
      <div className="relative">
        <PageHeader
          title="Platform setup"
          subtitle="OAuth credentials, redirect URIs, and feature toggles for every social platform."
          testidPrefix="admin-platform-setup"
        />
        <div className="rounded-md border border-[color:rgba(255,138,61,0.35)] bg-[color:rgba(255,138,61,0.04)] p-3 mb-5 text-xs text-[color:var(--accent-warm)] flex items-start gap-2">
          <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
          <div className="leading-relaxed">
            <strong className="text-[color:var(--text-1)]">Owner-only setup.</strong>{" "}
            Anything you change here saves instantly and overrides .env defaults. Customers will only
            see the public Connect flow once a platform is fully configured.
          </div>
        </div>
        <AdminConnectionsPanel />
      </div>
    </div>
  );
}
